export var DataGridEvents = {
    //raised when the data-grid detached event is rised
    // detail object in $event is :
    // {}
    //
    unloaded: "unloaded",
    //raised when a double click is performed on an item
    // detail object in $event is :
    // {
    //  item: any, 
    //  rowItem: RowItem, 
    //  identifier: string
    // }
    //
    doubleClick: "double-click",
    //raised when a new row is inserted in the grid
    // detail object in $event is :
    // {
    //  item: any, 
    //  rowItem: RowItem, 
    //  identifier: string
    // }
    //
    newItemPushed: "new-item-pushed",
    //raised when an item is selected
    //raised when a double click is performed on an item
    // detail object in $event is :
    // {
    //  item: any, 
    //  row: RowItem, 
    //  identifier: string
    // }
    //
    itemSelected: "item-selected",
    //raised when an item is selected
    //raised when a double click is performed on an item
    // detail object in $event is :
    // {
    //  eventSource: string,
    //  identifier: string
    // }
    //
    reloadEnded: "reload-ended",
    //raised when reloadData function is called
    //raised when an item is selected
    //raised when a double click is performed on an item
    // detail object in $event is :
    // {
    //  eventSource: string,
    //  identifier: string
    // }
    //
    reloadStarted: "reload-started",
    //raised when an item is moved from is position to take the place of another
    // detail object in $event is :
    // {
    //    fromIndex: number,
    //    toIndex: number,
    //    item: any,
    //    identifier: string
    // }
    //
    itemMoved: "item-moved",
    //called when the expan icon of the group is toggle (data grid must be with grouped data)
    // detail object in $event is :
    // {
    //    item: any,
    //    row: any,
    //    identifier: string
    // }
    //
    groupExpanderToggled: "group-expander-toggled"
};
